import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, isRef as _isRef, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5808e225"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "content-wrap"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "operator-line" }
const _hoisted_4 = { class: "default-item" }
const _hoisted_5 = { class: "update-item" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 1,
  class: "empty-message"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "暂无发票", -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "button-wrap" }

import { useRouter } from 'vue-router'
import { PullRefresh, Button } from 'vant'
import { computed, onMounted, ref } from 'vue'
import { formatInvoiceItem } from '@/types/invoice'
import { invoiceEditItemStorageKey } from './definition'
import { commonErrorHandle } from '@/utils/error-handle'
import { InvoiceUserSelectStorage } from '@/storage/invoice'
import { getUserInvoiceList, removeInvocie } from '@/apis/invoice'
import { showConfirmModal, showToastLoading, showToastSuccess } from '@/utils/tools'
import AppHeader from '@/components/Header.vue'
import CommonFooterWrap from '@/components/CommonFooterWrap.vue'
import UserInvoiceBaseInfo from '@/components/invoice/invoice-base-info.vue'
import useCommonList, { PageListResut } from '@/compositions/useCommonList'


export default /*#__PURE__*/_defineComponent({
  __name: 'user-invoice-list',
  setup(__props) {

const activeGuid = ref('')
const $router = useRouter()
const canConfirm = computed(() => {
  return (
    activeGuid.value !== '' &&
    dataList.value.filter((item) => item.guid === activeGuid.value).length
  )
})
async function queryList(): Promise<PageListResut<formatInvoiceItem>> {
  try {
    const data = await getUserInvoiceList()
    return {
      data,
      total: 1,
      current_page: 1,
    }
  } catch (error) {
    commonErrorHandle(error)
    return Promise.reject(error)
  }
}

// 点击选择发票抬头
function selectedHandle(guid: string) {
  activeGuid.value = guid
}
// 去往编辑页面
function toEdit(item: formatInvoiceItem) {
  sessionStorage.setItem(invoiceEditItemStorageKey, JSON.stringify(item))
  $router.push({
    name: 'invoice-edit',
    query: {
      guid: item.guid,
    },
  })
}
// 新增发票
function addNewInvoice() {
  $router.push({
    name: 'invoice-edit',
  })
}

// 删除发票
async function deleteInovice(item: formatInvoiceItem) {
  try {
    await showConfirmModal({
      title: '删除发票抬头？',
      message: '',
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: '确定删除',
      className: 'nongfu-dialog-confirm-common-class',
    })
  } catch (error) {
    return
  }
  try {
    showToastLoading()
    await removeInvocie({ guid: item.guid })
    showToastSuccess('删除成功')
    onRefresh()
  } catch (error) {
    commonErrorHandle(error)
  }
}

const { refreshing, onRefresh, dataList, loading } = useCommonList<formatInvoiceItem, undefined>(
  queryList,
  {
    emptyText: '暂无发票',
  }
)
function confirmHandle() {
  const current = dataList.value.filter((item) => item.guid === activeGuid.value)[0]
  if (current) {
    InvoiceUserSelectStorage.set(current)
  }
  $router.go(-1)
}
onMounted(() => {
  onRefresh()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "选择发票抬头" }),
    _createVNode(_unref(PullRefresh), {
      modelValue: _unref(refreshing),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(refreshing) ? (refreshing).value = $event : null)),
      onRefresh: _unref(onRefresh),
      class: "invoice-list-wrap"
    }, {
      default: _withCtx(() => [
        (_unref(dataList).length)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataList), (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.guid,
                  class: _normalizeClass(item.guid === activeGuid.value ? 'actived' : ''),
                  onClick: ($event: any) => (selectedHandle(item.guid))
                }, [
                  _createVNode(UserInvoiceBaseInfo, { item: item }, null, 8, ["item"]),
                  _createElementVNode("div", _hoisted_3, [
                    _withDirectives(_createElementVNode("div", _hoisted_4, "默认", 512), [
                      [_vShow, item.default]
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", {
                        class: "edit",
                        onClick: _withModifiers(($event: any) => (toEdit(item)), ["stop"])
                      }, "编辑", 8, _hoisted_6),
                      _createElementVNode("div", {
                        class: "remove",
                        onClick: _withModifiers(($event: any) => (deleteInovice(item)), ["stop"])
                      }, "删除", 8, _hoisted_7)
                    ])
                  ])
                ], 10, _hoisted_2))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_11))
      ]),
      _: 1
    }, 8, ["modelValue", "onRefresh"]),
    _createVNode(CommonFooterWrap, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_unref(Button), {
            round: "",
            class: "add-button",
            onClick: addNewInvoice
          }, {
            default: _withCtx(() => [
              _createTextVNode("新增发票抬头")
            ]),
            _: 1
          }),
          _createVNode(_unref(Button), {
            class: "xa-vant-button",
            round: "",
            disabled: !_unref(canConfirm),
            onClick: confirmHandle
          }, {
            default: _withCtx(() => [
              _createTextVNode("确定")
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})